import { gql } from "@apollo/client";

export const GET_ADDRESS = gql`
  query address($id: ID!) {
    address(id: $id) {
      id
      addressName
      address1
      address2
      city
      state
      country
      zipcode
      status
      companyId
      defaultLocation
    }
  }
`;

export const GET_ADDRESSES = gql`
  query addresses(
    $first: Int
    $after: String
    $before: String
    $companyId: ID
    $status: String
  ) {
    addresses(
      first: $first
      after: $after
      before: $before
      companyId: $companyId
      status: $status
    ) {
      edges {
        cursor
        node {
          id
          addressName
          address1
          address2
          city
          state
          country
          zipcode
          status
          defaultLocation
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

export const GET_DEFAULT_ADDRESS = gql`
  query defaultAddress($companyId: ID!) {
    defaultAddress(companyId: $companyId) {
      id
      addressName
      address1
      address2
      city
      state
      country
      zipcode
      status
      defaultLocation
    }
  }
`;

export const ADD_ADDRESS = gql`
  mutation addAddress($input: AddAddressInput) {
    addAddress(input: $input) {
      id
      addressName
      address1
      address2
      city
      state
      country
      zipcode
      status
    }
  }
`;

export const UPDATE_ADDRESS = gql`
  mutation updateAddress($id: ID!, $input: UpdateAddressInput) {
    updateAddress(id: $id, input: $input) {
      id
      addressName
      address1
      address2
      city
      state
      country
      zipcode
      status
    }
  }
`;
